import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import {
  ListingGroupSettings,
  SellerAccountClient,
} from 'src/WebApiController';

export const useListingGroupSellerAccountSettings = () => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  const queryClient = useQueryClient();
  const queryKey = [
    'SellerAccountClient.getListingGroupSettings',
    activeAccountWebClientConfig.activeAccountId,
  ];

  const shouldQuery = activeAccountWebClientConfig.activeAccountId != null;

  const query = useQuery({
    queryKey,
    queryFn: async () => {
      if (!shouldQuery) {
        return null;
      }
      return new SellerAccountClient(
        activeAccountWebClientConfig
      ).getListingGroupSettings();
    },
    enabled: shouldQuery,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const mutation = useMutation({
    mutationFn: async (settings: ListingGroupSettings) => {
      return new SellerAccountClient(
        activeAccountWebClientConfig
      ).mergeListingGroupSettings(settings);
    },
    onError: (err: ErrorTypes, settings) => {
      showErrorDialog('SellerAccountClient.mergeListingGroupSettings', err, {
        trackErrorData: { settings },
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetched: query.isFetched,
    mutation,
  };
};
